import styled from 'styled-components';
import StockModelPageTemplate from './StockModelPageTemplate';
import { rem } from 'polished';

export const StockModelPageStyled = styled(StockModelPageTemplate)`
    position: relative;

    .showMore {
        display: flex;
        justify-content: center;

        &--btn {
            max-width: ${rem('250px')};
            margin: ${rem('25px')} 0;
        }
    }

    button {
        cursor: pointer;
    }

    .filter-container {
        padding: 0 ${rem('10px')};
        margin: ${rem('15px')} auto 0;
        max-width: 1490px;
        width: 100%;
    }
`;
